import { render, staticRenderFns } from "./ListDeliveries.vue?vue&type=template&id=4ec5243a&scoped=true&lang=pug"
import script from "./ListDeliveries.vue?vue&type=script&lang=js"
export * from "./ListDeliveries.vue?vue&type=script&lang=js"
import style0 from "./ListDeliveries.vue?vue&type=style&index=0&id=4ec5243a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5243a",
  null
  
)

export default component.exports